import {
  getModule,
  Module,
  MutationAction,
  VuexModule
} from "vuex-module-decorators";
import store from "@/store";
import { CommonResponse } from "@/api/response";
import { RegisterRequest } from "@/api/stamp-setting/request";
import * as StampSettingAPI from "@/api/stamp-setting";
import { isSuccess } from "@/api/response";

const MODULE_NAME = "stamp-setting/register";

/**
 * アプリ内通知登録更新API（/regist-stamp-setting）のレスポンスを管理するストアモジュール
 */
@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class Register extends VuexModule {
  // state
  registerResponse: CommonResponse = {} as CommonResponse;

  // getters
  get isSuccess() {
    return isSuccess(this.registerResponse);
  }

  get getMessage() {
    return this.registerResponse.message;
  }

  get getPreviewUrl() {
    if (this.registerResponse.results) {
      return this.registerResponse.results.previewUrl;
    } else {
      return "";
    }
  }

  // MutationActions
  @MutationAction
  async register(registerRequest: RegisterRequest) {
    const registerResponse = await StampSettingAPI.register(registerRequest);
    return {
      registerResponse
    };
  }

  @MutationAction
  async clear() {
    return {
      registerResponse: {} as CommonResponse
    };
  }
}

export default getModule(Register);
